
	frappe.templates['sidebar'] = `<div class="body-sidebar-container {%= expanded ? 'expanded' : ''%}">
	<div class="body-sidebar-placeholder"></div>
		<div class="body-sidebar">
			<div class="dropdown-notifications hidden">
				<!-- contents are rendered by frappe.ui.Notifications -->
				<div class="notifications-list" role="menu"></div>
			</div>
			<div class="dropdown-background-tasks hidden">
				<div class="background-tasks-list" role="menu">
					<div class="background-tasks-header">
						<div class="bg-tasks-header-items"></div>
						<div class="bg-tasks-header-actions"></div>
					</div>
					<div class="background-tasks-body"></div>
				</div>
			</div>
			<div class="body-sidebar-top">
				<div class="sidebar-items">
				</div>
			</div>
			<div class="body-sidebar-cards"></div>
			<div class="body-sidebar-bottom">
				<div class="promotional-banners"></div>
				<p>
					<a class="onboarding-sidebar px-2">
						{%= frappe.utils.icon("user-check" , "sm", "", "", "text-ink-gray-7 current-color", true)%}
						 <span> {%= __("Getting Started") %} </span>
					</a>
				</p>
				<div class="nav-item dropdown-navbar-user dropdown-mobile mt-3">
					<a
						class="align-center btn-reset flex nav-link sidebar-user-button"
						style="width: 100%; min-height: 40px;"
						aria-label="{{ __("User Menu") }}"
					>
						<div> {{ avatar }} </div>
						<div class="avatar-name-email text-small overflow-hidden w-75" style="margin-left: 8px;">
							<span class="d-block text-truncate">
								{{ frappe.session.user_fullname }}
							</span>
							<span class="d-block text-secondary text-truncate" style="margin-top: -1px;">
								{{ frappe.session.user_email }}
							</span>
						</div>
					</a>
				</div>
			</div>
			<button
				class="collapse-sidebar-link sidebar-toggle-btn"
				aria-label="{%= __('Toggle Sidebar') %}"
				data-placement="right"
			>
				{%= frappe.utils.icon("chevron-left", "sm", "", "", "", true) %}
			</button>
			<div class="sidebar-resize-handle"></div>
		</div>
		<div class="overlay" style="z-index: 1021;"></div>
		<div class="user-onboarding"></div>
	</div>
</div>
`;
